enum AccessReportsCoverPageElementEnum {
  ProductType = "productType",
  Product = "product",
  ReportTitleOne = "reportTitleOne",
  ReportTitleTwo = "reportTitleTwo",
  ReportTitleThree = "reportTitleThree",
  To = "to",
}

export { AccessReportsCoverPageElementEnum };
